import React from 'react';
/** 
* BotSelectorBox Component
* This component renders a box with checkboxes for selecting bot types to show.
* @param {Object} props - The properties passed to the component.
* @param {Map} props.botsToShow - A Map containing bot types and their visibility state.
* @param {Function} props.setBotsToShow - Function to update the bot types visibility state.
* @param {Function} props.setLoading - Function to set the loading state.
* @param {string} props.header - The header text for the selector box.
* @returns {JSX.Element} The rendered component.
*/

const BotSelectorBox = (props) => {
    // Handler to toggle checkbox state
    const handleCheckboxChange = (item) => {
        props.setBotsToShow(prev => {
            const updated = new Map(prev);
            updated.set(item, !updated.get(item));
            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const selectedAnyBotsArray = Array.from( props.botsToShow).filter(([key, value]) => value)
        if (selectedAnyBotsArray.length === 0) {
            alert("Please select at least one bot type to show.");
        } else {
            console.log("Submitted botsToShow:",  props.botsToShow);
            props.setLoading(true);
        }
    };

    return (
        <div className={'selector-box '+props.className??""}>
            <div className='selector-box-heading'>{props.header}</div>
            <div className={'selector-box-items'}>
                {(() => {
                    const elements = [];
                    for (const [item, value] of  props.botsToShow.entries()) {
                        elements.push(
                            <div className='selector-box-item' key={item}>
                                <input
                                    type="checkbox"
                                    className='selector-box-input'
                                    checked={value}
                                    onChange={() => handleCheckboxChange(item)}
                                />
                                <label className='selector-box-label'>{item}</label>
                            </div>
                        );
                    }
                    return elements;
                })()}
            </div>
        </div>
    );
};

export default BotSelectorBox;